// extracted by mini-css-extract-plugin
var _1 = "ant-breadcrumb___KYsrR";
var _2 = "breadcrumb-wrapper___spN_0";
export { _1 as "ant-breadcrumb", _2 as "breadcrumb-wrapper" }
